export default __webpack_public_path__ + "static/media/Tarjeta.4d96e9d2.svg";